import React from "react";
import PageShell, { Reveal, SectionHeading, Tags } from "../components/PageShell";
import { education, publication, activities } from "../data/profile";
import "../styles/Education.scss";

function Education() {
  const { main, training, earlier } = education;

  return (
    <PageShell slug="education">
      <section className="edu-main">
        <Reveal className="card edu-degree">
          <div className="edu-degree-top">
            <span className="eyebrow">
              {main.period} · {main.location}
            </span>
          </div>
          <h2>{main.institution}</h2>
          <p className="edu-degree-name">{main.degree}</p>
          <p className="edu-desc">{main.description}</p>
          <div>
            <span className="eyebrow edu-label">Relevant coursework</span>
            <Tags items={main.coursework} />
          </div>
        </Reveal>

        <Reveal className="card edu-gpa" delay={0.1}>
          <span className="eyebrow">Final GPA</span>
          <span className="stat-value">{main.gpa.split(" ")[0]}</span>
          <span className="edu-gpa-scale">out of 4.00</span>
        </Reveal>
      </section>

      <section className="grid-2">
        <Reveal className="card edu-training">
          <span className="eyebrow">Intensive training · {training.period}</span>
          <h3>{training.institution}</h3>
          <p className="edu-degree-name">{training.degree}</p>
          <p className="edu-desc">{training.description}</p>
          <div className="edu-mini-stats">
            <div>
              <span className="stat-value">250h</span>
              <span>training</span>
            </div>
            <div>
              <span className="stat-value">60</span>
              <span>selected participants</span>
            </div>
          </div>
        </Reveal>

        <Reveal className="card edu-pub" delay={0.1}>
          <span className="eyebrow">Research · {publication.year}</span>
          <h3>{publication.title}</h3>
          <p className="edu-desc">
            {publication.authors} — {publication.venue}.
          </p>
          <a className="text-link" href={publication.url} target="_blank" rel="noopener noreferrer">
            Read on DOI ↗
          </a>
        </Reveal>
      </section>

      <section className="grid-2">
        <div>
          <SectionHeading eyebrow="Beyond class" title="Activities" />
          <ul className="edu-list">
            {activities.map((a, i) => {
              const [role, ...rest] = a.split(" — ");
              return (
                <Reveal as="li" key={a} delay={i * 0.05}>
                  <span className="edu-list-role">{role}</span>
                  <span>{rest.join(" — ")}</span>
                </Reveal>
              );
            })}
          </ul>
        </div>
        <div>
          <SectionHeading eyebrow="Earlier" title="School years" />
          <ul className="edu-list">
            {earlier.map((e, i) => (
              <Reveal as="li" key={e.institution} delay={i * 0.05}>
                <span className="edu-list-role">{e.period}</span>
                <span>
                  <strong>{e.institution}</strong> · {e.degree}
                </span>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>
    </PageShell>
  );
}

export default Education;
